import { MeModel } from '@simploshop-models/me.model'

export const ME_MODEL_EMBEDS = [
    MeModel.EMBED_CUSTOMER_LATEST_CART_ID,
    MeModel.EMBED_CUSTOMER_PRODUCT_WISH_LIST,
    MeModel.EMBED_CUSTOMER_PAIRINGS,
] as const
